import { render, staticRenderFns } from "./AssinaturasExpiradasTable.vue?vue&type=template&id=cf6fd494"
import script from "./AssinaturasExpiradasTable.vue?vue&type=script&lang=ts"
export * from "./AssinaturasExpiradasTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports